// extracted by mini-css-extract-plugin
export default {"card":"StatCard_card__1wKus","value":"StatCard_value__7tz0U","title":"StatCard_title__Piidz"};